<template>
  <div
    class="prize"
    :style="empty ? {'background': '#fff'} : {}"
  >
    <header>
      <ul>
        <li
          :class="{navColor: navIndex==index}"
          v-for="(item, index) in navList"
          :key="index"
          @click="navClick(index)"
        >
          {{item}}
          <span v-if="navIndex==index"></span>
        </li>
      </ul>
    </header>
    <div v-if="imgUrl.length > 0" style="margin-top: 0.55rem;padding: 0rem 0.1rem;position: relative;" @click="goImgUrl(targetUrl)">
       <img :src="imgUrl" style="width:100%;display: block;">
    </div>
    <Scroller
      :is-refresh-data.sync="refresh"
      :is-loading-data.sync="loading"
      :is-finished-data.sync="finished"
      :no-data-text-data.sync="noDataText"
      @on-infinite="onInfinite"
      @on-refresh="onRefresh"
      class="my_scroller"
      ref="my_scroller"
    >
      <div class="order" :class="{'orders': imgUrl.length<=0}">
        <ul>
          <li
            v-for="(item, index) of list"
            :key="index"
            :style="lisStyle"
          >
            <b
              class="check"
              v-if="editor"
            >
              <input
                :id="'checkbox'+index"
                @click="check(index)"
                type="checkbox"
                :value="index"
                :checked='item.isChecked'
              >
              <label :for="'checkbox'+index">
                <i :class="{'on':item.isChecked}"></i>
              </label>
            </b>
            <div class="flex-1">
              <div class="orderBox" :class="{'orderBox_old': item.newsku && item.newsku.skuid}">
                <div
                  class="orderNo"
                  v-if="item.order_no && item.order_time && (item.prize_type == 0 || item.prize_type == 3)"
                >
                  <p>{{item.order_from}}&nbsp;{{item.order_no}}</p>
                  <p>{{item.order_time}}</p>
                </div>
                <div
                  class="orderlist"
                  v-if="item.prize_type == 0 || item.prize_type == 3"
                  @click="orderdetails(navIndex, item)"
                >
                  <div class="maskbox" v-if="item.newsku && item.newsku.skuid">
                    <img v-lazy="item.img_path">
                    <div class="mask f13">售罄</div>
                  </div>
                  <img v-if="!(item.newsku && item.newsku.skuid)" v-lazy="item.img_path">
                  <div class="ordercontent">
                    <p class="flex-js-ac f0">
                      <label>{{item.name.length > 28 ? item.name.slice(0, 28) + '...' : item.name}}
                        <img v-if="item.isoversea == 1" src="../../assets/images/haiwai.png">
                      </label>
                      <span class="f10" style="color: #6C6C6C;">X{{item.num}}</span>
                    </p>
                    <b>{{item.spec}}</b>
                    <div v-if="navIndex == 0" class="expiretime">{{'获取时间：' + item.gettime}}</div>
                    <div v-if="navIndex == 0 && item.expiretime" class="expiretime">{{'失效时间：' + item.expiretime}}</div>
                    <div class="span">
                      <div class="goods_price">
                      <span class="smallprice">
                        <sub>¥</sub>
                        <b>{{String(item.price).slice(0, String(item.price).indexOf('.'))}}</b>
                        <sup>{{String(item.price).slice(String(item.price).indexOf('.'), String(item.price).length)}}</sup>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="orderlist nmn_orderlist"
                  v-if="item.prize_type == 1 || item.prize_type == 2"
                  @click="orderdetails(navIndex, item)"
                >
                  <div class="maskbox" v-if="item.newsku && item.newsku.skuid">
                    <img v-lazy="item.nmn_img_path">
                    <div class="mask f13">售罄</div>
                  </div>
                  <img v-if="!(item.newsku && item.newsku.skuid)" v-lazy="item.nmn_img_path">
                  <div class="ordercontent">
                    <p class="f0">
                      <label>{{item.nmn_name.length > 28 ? item.nmn_name.slice(0, 28) + '...' : item.nmn_name}}</label>
                    </p>
                    <b>
                      <span>活动时间：</span> {{item.begin_time.replace(/-/g, '.')}}-{{item.end_time.replace(/-/g, '.')}}
                    </b>
                    <b>
                      <span>获取时间：</span> {{item.gettime}}
                    </b>
                  </div>
                </div>
                <div class="btnbox" v-if="!(item.newsku && item.newsku.skuid)">
                  <button
                    v-if="item.prize_type == 3 && item.drawnum"
                    class="btn pull redBorBtn"
                    @click.stop="$router.push('/getDetails?prizeid='+ item.prize_id)"
                  >领取详情({{item.drawnum}})</button>
                  <button
                    v-if="item.isget != 3 && item.prize_status == 1 && (item.prize_type == 1 || item.prize_type == 2 || item.prize_type == 3)"
                    class="btn pull redBorBtn"
                    @click.stop="goShare(item)"
                  >赠送</button>
                  <button
                    v-if="navIndex == 0 && item.prize_status == 3 && (item.prize_type == 1 || item.prize_type == 2)"
                    class="pull pullgray redBorBtn grayBorBtn"
                  >已赠送</button>
                  <button
                    v-if="navIndex == 0 && item.isget != 3 && ((item.prize_status == 1 && (item.prize_type == 1 || item.prize_type == 2)) || item.prize_type == 0 || item.prize_type == 3)"
                    class="pull"
                    :class="{'pullgray': item.isget == 4}"
                    @click="drawClick(item)"
                  >领取</button>
                  <button
                    v-if="navIndex == 1"
                    class="pull pullgray"
                  >已领取</button>
                  <button
                    v-if="navIndex == 0 && item.prize_status == 2 && (item.prize_type == 1 || item.prize_type == 2)"
                    class="pull pullgray"
                  >已使用</button>
                  <button
                    v-if="navIndex == 0 && (item.isget == 3 || (item.prize_status == 4 && (item.prize_type == 1 || item.prize_type == 2)))"
                    class="pull pullgray"
                  >已失效</button>
                </div>
                <div v-if="item.newsku && item.newsku.skuid" class="instructions color-FC0324 f11">说明：该商品已售完，已为您更换为下方福利</div>
              </div>
              <div class="orderBox" v-if="item.newsku && item.newsku.skuid">
                <div
                  class="orderNo"
                  v-if="item.newsku.order_no && item.newsku.order_time && item.newsku.prize_type == 0"
                >
                  <p>{{item.newsku.order_from}}&nbsp;{{item.newsku.order_no}}</p>
                  <p>{{item.newsku.order_time}}</p>
                </div>
                <div
                  class="orderlist"
                  v-if="item.newsku.prize_type == 0"
                  @click="orderdetails(navIndex, item.newsku)"
                >
                  <img v-lazy="item.newsku.img_path">
                  <div class="ordercontent">
                    <p class="flex-js-ac f0">
                      <label>{{item.newsku.name.length > 28 ? item.newsku.name.slice(0, 28) + '...' : item.newsku.name}}
                        <img v-if="item.newsku.isoversea == 1" src="../../assets/images/haiwai.png">
                      </label>
                      <span class="f10" style="color: #6C6C6C;">X{{item.num}}</span>
                    </p>
                    <b>{{item.newsku.spec}}</b>
                    <div v-if="navIndex == 0" class="expiretime">{{'获取时间：' + item.newsku.gettime}}</div>
                    <div v-if="navIndex == 0 && item.newsku.expiretime" class="expiretime">{{'失效时间：' + item.newsku.expiretime}}</div>
                    <div class="span">
                      <div class="goods_price">
                      <span class="smallprice">
                        <sub>¥</sub>
                        <b>{{String(item.newsku.price).slice(0, String(item.newsku.price).indexOf('.'))}}</b>
                        <sup>{{String(item.newsku.price).slice(String(item.newsku.price).indexOf('.'), String(item.newsku.price).length)}}</sup>
                      </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="orderlist nmn_orderlist"
                  v-if="item.newsku.prize_type == 1 || item.newsku.prize_type == 2"
                  @click="orderdetails(navIndex, item.newsku)"
                >
                  <img v-lazy="item.newsku.nmn_img_path">
                  <div class="ordercontent">
                    <p class="f0">
                      <label>{{item.newsku.nmn_name.length > 28 ? item.newsku.nmn_name.slice(0, 28) + '...' : item.newsku.nmn_name}}</label>
                    </p>
                    <b>
                      <span>活动时间：</span> {{item.newsku.begin_time.replace(/-/g, '.')}}-{{item.newsku.end_time.replace(/-/g, '.')}}
                    </b>
                    <b>
                      <span>获取时间：</span> {{item.newsku.gettime}}
                    </b>
                  </div>
                </div>
                <div class="btnbox">
                  <button
                    v-if="item.prize_type == 3 && item.drawnum"
                    class="btn pull redBorBtn"
                    @click.stop="$router.push('/getDetails?prizeid='+ item.prize_id)"
                  >领取详情({{item.drawnum}})</button>
                  <button
                    v-if="navIndex == 0 && item.newsku.isget != 3 && item.newsku.prize_status == 1 && (item.newsku.prize_type == 1 || item.newsku.prize_type == 2 || item.newsku.prize_type == 3)"
                    class="btn pull redBorBtn"
                    @click.stop="goShare(item.newsku)"
                  >赠送</button>
                  <button
                    v-if="navIndex == 0 && item.newsku.prize_status == 3 && (item.newsku.prize_type == 1 || item.newsku.prize_type == 2)"
                    class="pull pullgray redBorBtn grayBorBtn"
                  >已赠送</button>
                  <button
                    v-if="navIndex == 0 && item.newsku.isget != 3 && ((item.newsku.prize_status == 1 && (item.newsku.prize_type == 1 || item.newsku.prize_type == 2 || item.newsku.prize_type == 3)) || item.newsku.prize_type == 0)"
                    class="pull"
                    @click="drawClick(item.newsku)"
                  >领取</button>
                  <button
                    v-if="navIndex == 1"
                    class="pull pullgray"
                  >已领取</button>
                  <button
                    v-if="navIndex == 0 && item.newsku.prize_status == 2 && (item.newsku.prize_type == 1 || item.newsku.prize_type == 2)"
                    class="pull pullgray"
                  >已使用</button>
                  <button
                    v-if="navIndex == 0 && (item.newsku.isget == 3 || (item.newsku.prize_status == 4 && (item.newsku.prize_type == 1 || item.newsku.prize_type == 2)))"
                    class="pull pullgray"
                  >已失效</button>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </Scroller>
    <div
      v-if="empty" class="noprize">
      <empty :path="'noPrize'"></empty>
    </div>
    <footer v-if="all && navIndex != 0">
      <b
        v-if="editor"
        class="check"
      >
        <input
          id="'checkboxAll"
          @click="checkAllClick"
          type="checkbox"
          value="all"
          :checked='checkedAll'
        >
        <label for="'checkboxAll">
          <i :class="{'on':checkedAll}"></i>
          全选
        </label>
        <div class="clear"></div>
      </b>
      <p
        v-if="!editor && navIndex == 0"
        @click="editorClick"
      >批量领取</p>
      <p
        v-if="!editor && navIndex == 1"
        @click="editorClick"
      >编辑</p>
      <div
        class="btnBox"
        style="font-size: 0"
      >
        <i
          v-if="editor"
          style="font-size:0.13rem;
            font-weight:400;
            color:rgba(68,68,68,1);
            line-height:0.18rem;
            font-style: normal;
            margin-right: 0.15rem;"
          @click="cancelClick"
        >取消</i>
        <button
          style="display: inline-block"
          v-if="(editor && navIndex == 0) && !deleteBool"
          class="btn pullBtn pullGrayBtn"
        >领取</button>
        <button
          style="display: inline-block"
          v-if="(editor && navIndex == 0) && deleteBool"
          class="btn pullBtn pullRedBtn"
          @click="drawClick"
        >领取</button>
        <button
          style="display: inline-block"
          v-if="(editor && navIndex == 1) && !deleteBool"
          class="btn delBtn delGrayBtn"
        >删除</button>
        <button
          style="display: inline-block"
          v-if="(editor && navIndex == 1) && deleteBool"
          class="btn delBtn delRedBtn"
          @click="deleteClick"
        >删除</button>
      </div>
    </footer>
    <van-overlay
      :show="showshare"
      z-index="99"
    >
    </van-overlay>
    <div
      class="sharecontainer sharetitle"
      v-if="showshare === true"
    >
      <img src="/static/images/sharemc.png" />
      <van-button
        round
        plain
        type="danger"
        class="know"
        @click="showshare = false"
      >我知道了</van-button>
    </div>
  </div>
</template>

<script>
import { customRequestAjax } from '@/axiosApi'
import Scroller from '../common/Scroller'
import empty from '../emptypage/empty'
import { isWeixin, fenxiang, Base64, appid } from '../../assets/common/js/config'

export default {
  name: 'myPrize',
  data() {
    return {
      navList: ['未领取', '已领取'],
      navIndex: 0,
      empty: false,
      all: false,
      editor: false,
      checkedAll: false,
      deleteBool: false,
      chooseRec: {
        list: [],
        index: [],
      },
      chooseDel: {
        idlist: [],
        index: [],
      },
      lisStyle: {},
      list: [],
      refresh: false,
      loading: false,
      finished: false,
      title: '',
      desc: '',
      img: '',
      showshare: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——',
      imgUrl:'',
      targetUrl:''
    }
  },
  components: {
    Scroller,
    empty,
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'myprize' })
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == '/') {
      // 当前页面刷新不需要切换位置
      next(vm => {
        vm.nowPage = 0
      })
    } else {
      next((vm) => {
        // if (vm && vm.$refs.my_scroller) {
        //   // 通过vm实例访问this
        //   setTimeout(function () {
        //     window.scrollTo(0, sessionStorage.askPositon, false)
        //   }, 0) // 同步转异步操作
        // }
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    // sessionStorage.askPositon =
    //   this.$refs.my_scroller && this.$refs.my_scroller.clickItem()
    next()
  },
  methods: {
    getData: function (fn1) {
      var urling =
        'Wxmall/Prizes/getUnreceivedPrizesList?pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      var urled =
        'Wxmall/Prizes/getReceivedPrizesList?pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      var that = this
      if (that.navIndex + 1 === 1) {
        customRequestAjax(urling).then((res) => {
          if (res.data.code === 200) {
            if (that.nowPage === 1) {
              that.imgUrl = res.data.act_img
              that.targetUrl = res.data.act_target
              res.data.prizeslist.map((item) => {
                item.isChecked = false
              })
              that.list = res.data.prizeslist
              if (that.list && that.list.length > 0) {
                that.all = true
              }
              that.refresh = false
            } else {
              res.data.prizeslist.map((item) => {
                item.isChecked = false
              })
              that.list = that.list.concat(res.data.prizeslist)
            }
            that.loading = false
            if (res.data.prizeslist.length < that.pagesize) {
              that.finished = true
              if (that.list && that.list.length <= 0) {
                that.empty = true
                that.all = false
              } else {
                that.all = true
                that.empty = false
              }
            } else {
              that.finished = false
            }
            if (typeof fn1 === 'function') {
              fn1()
            }
          }
        })
      } else if (this.navIndex + 1 === 2) {
        customRequestAjax(urled).then((res) => {
          if (res.data.code === 200) {
            if (that.nowPage === 1) {
              res.data.prizeslist.map((item) => {
                item.isChecked = false
              })
              that.list = res.data.prizeslist
              if (that.list && that.list.length > 0) {
                that.all = true
              }
              that.refresh = false
            } else {
              res.data.prizeslist.map((item) => {
                item.isChecked = false
              })
              that.list = that.list.concat(res.data.prizeslist)
            }
            that.loading = false
            if (res.data.prizeslist.length < that.pagesize) {
              that.finished = true
              if (that.list && that.list.length <= 0) {
                that.empty = true
                that.all = false
              } else {
                that.all = true
                that.empty = false
              }
            } else {
              that.finished = false
            }
            if (typeof fn1 === 'function') {
              fn1()
            }
          }
        })
      }
    },
    goImgUrl(url){
      if (url) {
        this.$clickburiedPoint({
          data: {
            buttonCode: 'prizeact'
          }
        })
        setTimeout(function () {
          location.href = url
        }, 100)
      }
    },
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      // this.list = []
      var that = this
      that.getData(function () {
        that.checkAllClick(false)
        that.editorClick(false)
      })
      // this.editorClick()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getData(function () {
        that.checkAllClick(that.checkedAll)
        // that.editorClick(that.checkedAll)
      })
      // }, 400)
    },
    check: function (index) {
      // 设置值，以供传递
      this.list[index].isChecked = !this.list[index].isChecked
      var idxAll = 0
      var idxDel = 0
      this.chooseRec.list = []
      this.chooseRec.index = []
      this.chooseDel.idlist = []
      this.chooseDel.index = []
      var that = this
      that.list.forEach((item, i) => {
        if (!item.isChecked) {
          that.checkedAll = false
          idxDel++
        } else {
          that.deleteBool = true
          if (that.navIndex === 0) {
            item.isprize = 1
            that.chooseRec.list.push(item)
            that.chooseRec.index.unshift(i)
            that.chooseDel.idlist = []
            that.chooseDel.index = []
          } else if (that.navIndex === 1) {
            that.chooseRec.list = []
            that.chooseRec.index = []
            that.chooseDel.idlist.push(item.prize_id)
            that.chooseDel.index.unshift(i)
          }
          idxAll++
        }
      })
      if (idxAll === this.list.length) {
        this.checkedAll = true
      }
      if (idxDel === this.list.length) {
        this.deleteBool = false
      }
    },
    editorClick: function (editor) {
      if (typeof editor === 'boolean') {
        this.editor = editor
      } else {
        this.editor = !this.editor
      }
      if (this.editor) {
        this.lisStyle = {
          marginRight: 0,
        }
      } else {
        this.lisStyle = {
          marginRight: '0.11rem',
        }
      }
    },
    cancelClick: function () {
      this.editor = !this.editor
      if (this.editor) {
        this.lisStyle = {
          marginRight: 0,
        }
      } else {
        this.lisStyle = {
          marginRight: '0.11rem',
        }
        this.checkAllClick(false)
      }
    },
    allCheck: function (check) {
      this.chooseRec.list = []
      this.chooseRec.index = []
      this.chooseDel.idlist = []
      this.chooseDel.index = []
      this.list.forEach((item, i) => {
        item.isChecked = check
        if (item.isChecked) {
          if (this.navIndex === 0) {
            this.chooseRec.list.push(item)
            this.chooseRec.index.unshift(i)
            this.chooseDel.idlist = []
            this.chooseDel.index = []
          } else if (this.navIndex === 1) {
            this.chooseRec.list = []
            this.chooseRec.index = []
            this.chooseDel.idlist.push(item.prize_id)
            this.chooseDel.index.unshift(i)
          }
        }
      })
    },
    checkAllClick: function (checkAll) {
      if (typeof checkAll === 'boolean') {
        this.checkedAll = checkAll
      } else {
        this.checkedAll = !this.checkedAll
      }
      if (this.checkedAll) {
        this.allCheck(true)
        this.deleteBool = true
      } else {
        this.allCheck(false)
        this.deleteBool = false
      }
    },
    navClick: function (id) {
      if (this.navIndex !== id) {
        this.empty = false
        this.all = false
        this.loading = true
        this.finished = false
        var that = this
        that.navIndex = id
        that.nowPage = 1
        that.list = []
        that.getData(null, function () {
          that.checkAllClick(false)
          that.editorClick(false)
        })
      }
      console.log(this.editor, this.navIndex, this.deleteBool)
    },
    goShare(items) {
      this.showshare = true
      var that = this,
        base = new Base64(),
        nmn318 = 0,
        coupon_type = items.prize_type == 1 ? 1 : items.prize_type == 2 ? 3 : items.prize_type == 3 ? 4 : 0
      if (items.begin_time && items.begin_time.indexOf('3-18') >= 0) {
        nmn318 = 1
      }
      that.title = items.title
      that.desc = items.desc
      that.img = items.img
      fenxiang({
        title: encodeURIComponent(that.title),
        desc: encodeURIComponent(that.desc),
        imgx: that.img,
        type: 'trancoupon',
        dataStr:
          'type=trancoupon&params=' +
          base.encode(
            JSON.stringify({
              mecouponid: items.prize_id,
              coupon_type: coupon_type,
              nmn318: nmn318,
            })
          ),
        path: 'myprize',
      })
    },
    drawClick: function (items) {
      if (items.isget == 4) {
        let time = items.canusetime.split('-')
        this.$toast(`奖品${parseInt(time[1])}月${parseInt(time[2])}日才能领取`)
        return
      }
      if (items.targeturl) {
        window.location = items.targeturl
        return
      }
      var haiwaiIndex = 0
      var neidiIndex = 0
      var xuniIndex = 0
      if (items.name) {
        if (items.ispay == 1) {
          this.drawPayItem(items)
          return
        }
        items.isprize = 1
        items.num = items.prize_type == 3 ? 1 : items.num
        this.chooseRec.list = []
        this.chooseRec.list.push(items)
        sessionStorage.setItem(
          'prize_choose_list',
          JSON.stringify(this.chooseRec.list)
        )
      } else {
        sessionStorage.setItem(
          'prize_choose_list',
          JSON.stringify(this.chooseRec.list)
        )
      }
      this.chooseRec.list.map((item) => {
        if (item.isoversea == 0) {
          neidiIndex++
        } else {
          haiwaiIndex++
        }
        if (item.isget == 0) {
          xuniIndex++
        }
      })
      if (neidiIndex == this.chooseRec.list.length && xuniIndex == 0) {
        this.checkAllClick(false)
        this.editorClick(false)
        this.$router.push('/orderprize')
      } else if (haiwaiIndex == this.chooseRec.list.length && xuniIndex == 0) {
        this.checkAllClick(false)
        this.editorClick(false)
        this.$router.push('/orderprize')
      } else if (xuniIndex > 0) {
        this.$toast('虚拟商品无需领取')
      } else {
        this.$toast('海外商品不能与普通商品一起购买！')
      }
    },
    drawPayItem: function (items) {
      var shopConfirmResult = {
        skuidArr: [],
        from: 2,
        orderfrom: 1,
        liveId: items.liveid ? [items.liveid] : [''],
        itemNum: [],
        totalmoney: parseFloat(items.price),
        totalnum: parseInt(items.num),
        communityid: items.communityid,
        prizeidArr: [items.prize_id]
      }

      if (this.$route.query.shareOpenid && this.$route.query.shareOpenid != appid) {
        shopConfirmResult.shareOpenid = this.$route.query.shareOpenid
      }

      shopConfirmResult.skuidArr.push(items.skuid)
      shopConfirmResult.itemNum.push(items.prize_type == 3 ? 1 : items.num)
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      sessionStorage.removeItem('choose_integral')
      sessionStorage.removeItem('choose_coupon')
      sessionStorage.removeItem('choose_product')
      sessionStorage.removeItem('oversea_List')
      this.$router.push('/order?prize=1&yl=1')
    },
    deleteClick: function () {
      var url = 'Wxmall/Prizes/deletePrizes'
      var data = {
        prizeids: this.chooseDel.idlist.join(),
      }
      customRequestAjax.post(url, data).then((res) => {
        if (res.data.code === 200) {
          this.chooseDel.index.map((item) => {
            this.list.splice(item, 1)
          })
          if (this.list.length <= 0) {
            this.empty = true
            this.all = false
          } else {
            this.checkAllClick(false)
            this.editorClick(false)
          }
        }
      })
    },
    orderdetails: function (index, items) {
      if (index == 1) {
        this.$router.push({
          path: '/orderdetails',
          query: {
            id: items.order_id,
          },
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.prize {
  header {
    z-index: 1;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    ul {
      background: #fff;
      display: flex;
      display: -o-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -webkit-flex;
      li {
        width: 50%;
        padding: 0.12rem 0;
        text-align: center;
        font-size: 0.15rem;
        font-weight: 400;
        color: #4b4b4b;
        line-height: 0.21rem;
        position: relative;
        &.navColor {
          font-weight: 600;
          color: #292929;
        }
        span {
          position: absolute;
          left: 50%;
          bottom: 0.065rem;
          transform: translateX(-50%);
          -o-transform: translateX(-50%);
          -moz-transform: translateX(-50%);
          -ms-transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          display: block;
          width: 0.24rem;
          height: 0.025rem;
          background: linear-gradient(90deg, #fc0324, #ff5168);
          background: -webkit-gradient(
            linear,
            left top,
            right top,
            from(#fc0324),
            to(#ff5168)
          );
          background: -moz-linear-gradient(90deg, #fc0324, #ff5168);
          background: -ms-linear-gradient(90deg, #fc0324, #ff5168);
          background: -o-linear-gradient(90deg, #fc0324, #ff5168);
        }
      }
    }
  }
  .order {
    &.orders {
      margin-top: 0.55rem;
    }
    ul {
      padding-bottom: 0.1rem;
      .check {
        width: 0.31rem;
        input {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
        }
        label {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          -webkit-transform: translateY(-50%);
          -o-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
        }
      }
      li {
        margin: 0.1rem 0.11rem 0;
        display: flex;
        display: -webkit-flex;
        display: -o-flex;
        display: -ms-flex;
        display: -moz-flex;
        position: relative;
        .orderBox {
          padding: 0.2rem 0.15rem 0.2rem;
          border-radius: 0.03rem;
          background: #fff;
          position: relative;
          flex: 1;
          -webkit-flex: 1;
          -o-flex: 1;
          -ms-flex: 1;
          -moz-flex: 1;
          &.orderBox_old {
            position: relative;
            z-index: 1;
            margin-bottom: -0.1rem;
            .orderlist {
              .ordercontent {
                p {
                  label {
                    color: #6c6c6c;
                  }
                }
                .span {
                  .goods_price {
                    color: #6C6C6C;
                    .smallprice {
                      b {
                        color: #6C6C6C;
                      }
                    }
                  }
                }
              }
              .maskbox {
                position: relative;
                width: 0.85rem;
                height: 0.85rem;
                margin-right: 0.07rem;
                img {
                  width: 100%;
                  height: 100%;
                }
                .mask {
                  position: absolute;
                  left: 0;
                  top: 0;
                  right: 0;
                  bottom: 0;
                  background: rgba(0, 0, 0, .3);
                  border-radius: 0.04rem;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: bold;
                  color: #FFFFFF;
                  text-align: center;
                  line-height: 0.85rem;
                }
              }
            }
            .instructions {
              position: absolute;
              left: 0.15rem;
              bottom: 0;
            }
          }
          .orderNo {
            font-size: 0;
            margin-top: -0.05rem;
            padding-bottom: 0.1rem;
            margin-bottom: 0.16rem;
            border-bottom: 1px solid #efefef;
            overflow: hidden;
            p {
              font-size: 0.12rem;
              font-weight: 400;
              line-height: 0.17rem;
              display: inline-block;
              &:first-of-type {
                color: rgba(68, 68, 68, 1);
                float: left;
              }
              &:last-of-type {
                color: rgba(153, 153, 153, 1);
                float: right;
              }
            }
          }
          .orderlist {
            display: flex;
            display: -moz-flex;
            display: -o-flex;
            display: -ms-flex;
            display: -webkit-flex;
            align-items: center;
            -moz-align-items: center;
            -o-align-items: center;
            -ms-align-items: center;
            -webkit-align-items: center;
            &.nmn_orderlist {
              align-items: flex-start;
              -moz-align-items: flex-start;
              -o-align-items: flex-start;
              -ms-align-items: flex-start;
              -webkit-align-items: flex-start;
            }
            > img {
              width: 0.85rem;
              height: 0.85rem;
              margin-right: 0.07rem;
            }
            .ordercontent {
              flex: 1;
              -webkit-flex: 1;
              -o-flex: 1;
              -moz-flex: 1;
              -ms-flex: 1;
              p {
                padding-bottom: 0.05rem;
                label {
                  font-size: 0.13rem;
                  font-weight: 400;
                  color: rgba(41, 41, 41, 1);
                  line-height: 0.14rem;
                }
                img {
                  width: 0.15rem;
                  height: 0.15rem;
                  margin-left: 0.03rem;
                  vertical-align: text-bottom;
                  margin-left: 0.03rem;
                  display: inline-block;
                }
                > b {
                  font-size: 0.1rem;
                  font-weight: 400;
                  color: rgba(108, 108, 108, 1);
                  line-height: 0.14rem;
                  display: block;
                }
              }
              > b {
                font-size: 0.11rem;
                font-weight: 400;
                color: rgba(108, 108, 108, 1);
                line-height: 0.16rem;
                display: block;
                margin-top: 0.05rem;
                margin-bottom: 0.04rem;
              }
              .span {
                display: block;
                font-size: 0;
                color: #fc0324;
                /*margin-bottom: 0.06rem;*/
                overflow: hidden;
                .goods_price {
                  font-size: 0.14rem;
                  /*line-height: .2rem;*/
                  color: #fc0324;
                  display: inline-block;
                  .smallprice {
                    font-size: 0;
                    b {
                      font-weight: 500;
                      font-size: 0.14rem;
                      color: #fc0324;
                      margin-left: 0;
                      padding: 0;
                    }
                  }
                  sub {
                    vertical-align: baseline;
                    font-size: 0.12rem;
                    font-weight: 400;
                  }
                  sup {
                    vertical-align: baseline;
                    font-weight: 500;
                    font-size: 0.11rem;
                  }
                }
                > i {
                  line-height: 0.2rem;
                  font-size: 0.1rem;
                  color: #6c6c6c;
                  font-style: normal;
                  text-decoration: line-through;
                  font-weight: 400;
                  margin-left: 0.03rem;
                }
              }
              .expiretime {
                color: #6c6c6c;
                font-size: 0.11rem;
              }
            }
          }
          .btnbox {
            /*position: absolute;*/
            /*right: 0.15rem;*/
            /*bottom: 0.2rem;*/
            display: flex;
            justify-content: flex-end;
            margin-top: 0.1rem;
            button {
              margin-left: 0.1rem;
              padding: 0 0.15rem;
              height: 0.23rem;
              min-width: 0.6rem;
            }
            .pull {
              /*padding: 0.03rem 0.12rem;*/
              background: rgba(252, 3, 36, 1);
              border: 0.01rem solid rgba(252, 3, 36, 1);
              border-radius: 0.14rem;
              font-size: 0.12rem;
              /*line-height: 0.12rem;*/
              font-weight: 400;
              color: rgba(255, 252, 252, 1);
              border: 0;
              outline: none;
              display: block;
              /*display: flex;*/
              /*display: -webkit-flex;*/
              /*display: -moz-flex;*/
              /*display: -ms-flex;*/
              /*display: -o-flex;*/
              /*justify-content: center;*/
              /*-webkit-justify-content: center;*/
              /*-moz-justify-content: center;*/
              /*-ms-justify-content: center;*/
              /*-o-justify-content: center;*/
              /*align-items: center;*/
              /*-webkit-align-items: center;*/
              /*-moz-align-items: center;*/
              /*-ms-align-items: center;*/
              /*-o-align-items: center;*/
              /*text-align: center;*/
              &.pullgray {
                background: #dddddd;
                border: 0.01rem solid #dddddd;
                /*padding: 0.03rem 0.12rem;*/
              }
              &.redBorBtn {
                background: transparent;
                border: 0.01rem solid #fc0324;
                color: #fc0324;
                bottom: 0;
                right: 0.7rem;
              }
              &.grayBorBtn {
                border: 0.01rem solid #dddddd;
                color: #dddddd;
                right: 0;
              }
            }
          }
        }
      }
    }
  }
  .check {
    font-weight: 400;
    position: relative;
    i {
      display: block;
      width: 0.18rem;
      height: 0.18rem;
      float: left;
      margin-right: 0.08rem;
      background: url(../../assets/images/uncheck.png) no-repeat left top;
      background-size: 100% 100%;
    }
    input {
      display: block;
      float: left;
      position: absolute;
      width: 0.18rem;
      height: 0.18rem;
      left: 0;
      outline: none;
      -webkit-appearance: none;
      opacity: 0;
    }
    .on {
      background: url(../../assets/images/check.png) no-repeat left top;
      background-size: 100% 100%;
    }
    label {
      float: left;
      font-size: 0.12rem;
      line-height: 0.18rem;
      color: #444;
    }
  }
  footer {
    height: 0.44rem;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.09rem 0.11rem 0.08rem;
    /*border-top: 1px solid #BDBDBD;*/
    box-shadow: 0 0.005rem 0 0.01rem rgba(0, 0, 0, 0.25);
    -webkit-box-shadow: 0 0.005rem 0 0.01rem rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0 0.005rem 0 0.01rem rgba(0, 0, 0, 0.25);
    -o-box-shadow: 0 0.005rem 0 0.01rem rgba(0, 0, 0, 0.25);
    -ms-box-shadew: 0 0.005rem 0 0.01rem rgba(0, 0, 0, 0.25);
    display: flex;
    display: -webkit-flex;
    display: -o-flex;
    display: -ms-flex;
    display: -moz-flex;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -o-justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    background: #fff;
    .clear {
      clear: both;
    }
    input {
      top: 0.06rem !important;
    }
    label {
      /*margin: 0.04rem 0 0.13rem 0 !important;*/
    }
    .btnDel {
      width: 0.7rem;
      height: 0.27rem;
      border-radius: 0.14rem;
      border: 1px solid rgba(184, 190, 200, 1);
      font-size: 0.12rem;
      font-weight: 400;
      color: rgba(184, 190, 200, 1);
      line-height: 0.17rem;
      background: #fff;
      outline: none;
      &.delete {
        border: 1px solid rgba(252, 3, 36, 1);
        color: rgba(252, 3, 36, 1);
      }
    }
    p {
      font-size: 0.13rem;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      line-height: 0.27rem;
      position: absolute;
      right: 0.11rem;
    }
    .btnBox {
      .btn {
        width: 0.7rem;
        height: 0.27rem;
        /*display: block;*/
        /*padding: 0.05rem 0.23rem;*/
        border-radius: 0.14rem;
        font-size: 0.12rem;
        font-weight: 400;
        /*line-height:0.17rem;*/
        outline: none;
        display: flex;
        display: -webkit-flex;
        display: -ms-flex;
        display: -moz-flex;
        display: -o-flex;
        justify-content: center;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        -o-justify-content: center;
        align-items: center;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -o-align-items: center;
        &.pullBtn {
          color: #fffcfc;
          border: 1px solid transparent;
        }
        &.pullGrayBtn {
          background: rgba(221, 221, 221, 1);
        }
        &.pullRedBtn {
          background: rgba(252, 3, 36, 1);
        }
        &.delBtn {
          color: #fffcfc;
          background: none;
        }
        &.delGrayBtn {
          color: rgba(184, 190, 200, 1);
          border: 1px solid rgba(184, 190, 200, 1);
        }
        &.delRedBtn {
          color: rgba(252, 3, 36, 1);
          border: 1px solid rgba(252, 3, 36, 1);
        }
      }
    }
  }
  .noprize {
    flex: 1;
    -webkit-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    -o-flex: 1;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}

.sharecontainer {
  position: fixed;
  width: 100%;
  z-index: 100;
  height: 100%;
  left: 0;
  top: 0;
}
.sharecontainer img {
  position: absolute;
  top: 0.2rem;
  right: 0.73rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 50%;
}
.sharecontainer .know {
  width: 1.09rem;
  height: 0.36rem;
  line-height: 0.36rem;
  color: #fff;
  border-color: #fff;
  background: transparent;
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  margin-left: -0.54rem;
}
</style>
// <style lang="scss">
// .prize {
//   .my_scroller {
//     padding-top: 0rem;
//   }
// }
// </style>



// WEBPACK FOOTER //
// src/components/prize/myPrize.vue